/** Canonical keys — spellings must match backend / route rules exactly. */

export const PERMISSION_DENIED_MESSAGE =
  "You don't have permission to perform this action. Contact your administrator to request access.";

export const PERMISSIONS = {
  ACCESS_COMPANY_MAILBOX: 'ACCESS_COMPANY_MAILBOX',
  ACCESS_DOCUMENT_TEMPLATES: 'ACCESS_DOCUMENT_TEMPLATES',
  ACCESS_MAILBOX: 'ACCESS_MAILBOX',
  ACCESS_QUESTIONNAIRES: 'ACCESS_QUESTIONNAIRES',
  ADD_APPLICATION_NOTE: 'ADD_APPLICATION_NOTE',
  ADD_CANDIDATE_NOTE: 'ADD_CANDIDATE_NOTE',
  ADD_JOB_NOTE: 'ADD_JOB_NOTE',
  ADD_USERS_TO_CHILD_COMPANY: 'ADD_USERS_TO_CHILD_COMPANY',
  BILLING_FULL_ACCESS: 'BILLING_FULL_ACCESS',
  COPY_APPLICATION: 'COPY_APPLICATION',
  CREATE_CHILD_COMPANY: 'CREATE_CHILD_COMPANY',
  CREATE_ACCOUNT: 'CREATE_ACCOUNT',
  CREATE_CV: 'CREATE_CV',
  CREATE_DEPARTMENT: 'CREATE_DEPARTMENT',
  CREATE_FORM: 'CREATE_FORM',
  CREATE_INTERVIEW_SLOT: 'CREATE_INTERVIEW_SLOT',
  CREATE_UPDATE_JOB: 'CREATE_UPDATE_JOB',
  CREATE_LICENSE_REQUEST: 'CREATE_LICENSE_REQUEST',
  CREATE_TEMPLATE: 'CREATE_TEMPLATE',
  DECLINE_APPLICATION: 'DECLINE_APPLICATION',
  DELETE_DEPARTMENT: 'DELETE_DEPARTMENT',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',
  DELETE_JOB: 'DELETE_JOB',
  EXTEND_JOB_EXPIRY: 'EXTEND_JOB_EXPIRY',
  EXTERNAL_CALENDAR_CRUD: 'EXTERNAL_CALENDAR_CRUD',
  FOLLOW_JOB: 'FOLLOW_JOB',
  HIRING_PLANS_APPROVE: 'HIRING_PLANS_APPROVE',
  MANAGE_DECLINE_REASONS: 'MANAGE_DECLINE_REASONS',
  MANAGE_DOCUMENTS: 'MANAGE_DOCUMENTS',
  MANAGE_EVENTS: 'MANAGE_EVENTS',
  MANAGE_FORMS: 'MANAGE_FORMS',
  MANAGE_APPLICATION_FORMS: 'MANAGE_APPLICATION_FORMS',
  MANAGE_APPLICATIONS: 'MANAGE_APPLICATIONS',
  MANAGE_APPROVERS: 'MANAGE_APPROVERS',
  MANAGE_API_HUB: 'MANAGE_API_HUB',
  MANAGE_AUTOMATION_WORKFLOWS: 'MANAGE_AUTOMATION_WORKFLOWS',
  MANAGE_CANDIDATE_SOURCE: 'MANAGE_CANDIDATE_SOURCE',
  MANAGE_CANDIDATES: 'MANAGE_CANDIDATES',
  MANAGE_CAREERSITE: 'MANAGE_CAREERSITE',
  MANAGE_COMPANY_PROFILE: 'MANAGE_COMPANY_PROFILE',
  MANAGE_COPYWRITE: 'MANAGE_COPYWRITE',
  MANAGE_E_SIGNER: 'MANAGE_E_SIGNER',
  MANAGE_PIPELINE_TEMPLATES: 'MANAGE_PIPELINE_TEMPLATES',
  MANAGE_REPORT_ANALYTICS: 'MANAGE_REPORT_ANALYTICS',
  MANAGE_SKILLS: 'MANAGE_SKILLS',
  MANAGE_SLOTS: 'MANAGE_SLOTS',
  MANAGE_TAGS: 'MANAGE_TAGS',
  MANAGE_TALENT_POOLS: 'MANAGE_TALENT_POOLS',
  MANAGE_INTERVIEWS: 'MANAGE_INTERVIEWS',
  MANAGE_JOB_STAGES: 'MANAGE_JOB_STAGES',
  MANAGE_WORKING_HOURS: 'MANAGE_WORKING_HOURS',
  MANAGE_RETENTION_POLICIES: 'MANAGE_RETENTION_POLICIES',
  MANAGE_ROLES: 'MANAGE_ROLES',
  MANAGE_TEMPLATES: 'MANAGE_TEMPLATES',
  MANAGE_VIDEO_PROFILES: 'MANAGE_VIDEO_PROFILES',
  RECEIVE_INTERVIEW_REMINDERS: 'RECEIVE_INTERVIEW_REMINDERS',
  READ_DASHBOARD_TIMELINE: 'READ_DASHBOARD_TIMELINE',
  SEARCH_CV: 'SEARCH_CV',
  SEND_EMAIL: 'SEND_EMAIL',
  SHARE_JOB: 'SHARE_JOB',
  SOCIAL_MEDIA_CRUD: 'SOCIAL_MEDIA_CRUD',
  SOCIAL_MEDIA_POSTING: 'SOCIAL_MEDIA_POSTING',
  SUBSCRIPTION_READ_ACCESS: 'SUBSCRIPTION_READ_ACCESS',
  TRANSFER_RESPONSIBILITIES: 'TRANSFER_RESPONSIBILITIES',
  UPDATE_CHILD_COMPANY: 'UPDATE_CHILD_COMPANY',
  UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
  UPDATE_DEPARTMENT: 'UPDATE_DEPARTMENT',
  VIEW_ALL_ACCOUNTS: 'VIEW_ALL_ACCOUNTS',
  VIEW_ALL_CANDIDATES: 'VIEW_ALL_CANDIDATES',
  VIEW_ALL_CVS: 'VIEW_ALL_CVS',
  VIEW_ALL_JOBS: 'VIEW_ALL_JOBS',
  VIEW_OWN_JOBS: 'VIEW_OWN_JOBS',
  VIEW_DOCUMENT_TEMPLATES: 'VIEW_DOCUMENT_TEMPLATES',
  VIEW_APPLICATION_FORMS: 'VIEW_APPLICATION_FORMS',
  VIEW_FORMS: 'VIEW_FORMS',
  VIEW_PAID_CVS: 'VIEW_PAID_CVS',
  VIEW_STAGE_APPLICATIONS: 'VIEW_STAGE_APPLICATIONS',
  VIEW_VIDEO_PROFILES: 'VIEW_VIDEO_PROFILES',
};

export const PERMISSION_LABELS = {
  [PERMISSIONS.VIEW_ALL_JOBS]: 'View all jobs',
  [PERMISSIONS.CREATE_UPDATE_JOB]: 'Create / update job',
  [PERMISSIONS.DELETE_JOB]: 'Delete job',
};

export function getPermissionDisplayLabel(key) {
  if (!key || typeof key !== 'string') return '';
  const t = key.trim();
  if (PERMISSION_LABELS[t]) return PERMISSION_LABELS[t];
  const s = t.toLowerCase().split('_').join(' ').trim();
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : t;
}
